import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlInfoBuildService } from '../ll-info-build.service';

@Component({
  selector: 'll-build-form',
  templateUrl: './ll-build-form.component.html',
  styleUrl: './ll-build-form.component.css'
})
export class LlBuildFormComponent {
  @ViewChild('mainDiv_ll_build_form') mainDiv: ElementRef;

  // Track which questions are currently being edited
  private editingQuestions = new Set<number>();

  constructor(
    private LlScrollpaneService: LlScrollpaneService,
    private LlPermissionsService: LlPermissionsService,
    private LlInfoBuildService: LlInfoBuildService,
  ) { }

  // ── Question Input Type List ──
  questionInputTypeList = [
    { label: 'Short Text', value: 'FTX' }, 
    { label: 'Long Text', value: 'FTX_LONG' }, 
    { label: 'Dollar', value: 'DOLLAR' },
    { label: 'Number', value: 'NUM' },
    { label: 'Decimal', value: 'NUMDEC' },
    { label: 'Multiple', value: 'MLP' },
  ];

  questionRequiredList = [
    { label: 'Required', value: 'R' },
    { label: 'Conditional', value: 'C' },
    { label: 'Optional', value: 'OPT' },
  ];

  bundle = {
    showPanel: false,
    mode: '',
    function: '',
    LlScrollpaneService: this.LlScrollpaneService,
    parentW: 0,
    parentH: 0,
    panelX: 0,
    panelY: 20,
    panelW: 0,
    panelH: 0,
    questionList: [] as any[],
  };

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showPanel = false;
    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;
    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.panelW = this.bundle.parentW;
      this.bundle.panelH = this.bundle.parentH - this.bundle.panelY - 50;
      this.bundle.showPanel = true;
    });

    this.getData()
  }

  getData() {
    this.LlInfoBuildService.NG_LL_infoReq_build_form_questions_get((arr: any[]) => {
      this.bundle.questionList = arr || [];

      console.log(arr)
    });
  }

  // ── Edit Mode Controls ──
  isEditing(studyQuestionId: number): boolean {
    return this.editingQuestions.has(studyQuestionId);
  }

  startEditing(studyQuestionId: number): void {
    this.editingQuestions.add(studyQuestionId);
  }

  // Helper to show friendly label (e.g. "Free Text" instead of "FTX")
  getInputTypeLabel(value: string): string {
    if (!value) return 'Not Set';
    const found = this.questionInputTypeList.find(item => item.value === value);
    return found ? found.label : value;
  }

  getRequiredLabel(value: string): string {
    if (!value) return 'Not Set';
    const found = this.questionRequiredList.find(item => item.value === value);
    return found ? found.label : value;
  }


  // ── Universal getter ──
  getQuestionValue(fieldName: string, studyQuestionId: number): any {
    const question = this.bundle.questionList.find(q => q.STUDYQUESTIONID === studyQuestionId);
    return question ? question[fieldName] : '';
  }

 
  // ── MLP Choices Change Handler ──
  onMLPChoicesChange(newValue: string, studyQuestionId: number): void {
    if (!newValue) {
      this.setQuestionValue('MLPCHOICES', '', studyQuestionId);
      return;
    }

    // 1. Replace all commas with space
    let cleaned = newValue.replace(/,/g, ' ');

    // 2. Split on whitespace and filter out empty strings
    let items = cleaned
      .trim()
      .split(/\s+/)
      .filter(item => item.length > 0);

    // 3. Join with comma, no spaces around commas
    const finalValue = items.join(',');

    // Update the model
    this.setQuestionValue('MLPCHOICES', finalValue, studyQuestionId);
  }

  // ── Single change handler for all fields ──
  onChanged(fieldName: string, newValue: string, studyQuestionId: number): void {
    this.setQuestionValue(fieldName, newValue, studyQuestionId);
  }

  // ── Universal setter ──
  setQuestionValue(fieldName: string, value: string, studyQuestionId: number): void {
    const question = this.bundle.questionList.find(q => q.STUDYQUESTIONID === studyQuestionId);
    if (question) {
      question[fieldName] = value;
    }
  }

  // ── Centralized save method ──
  saveQuestion(studyQuestionId: number): void {
    const question = this.bundle.questionList.find(q => q.STUDYQUESTIONID === studyQuestionId);
    if (question) {

      console.log(question)

      //this.LlInfoBuildService.NG_LL_infoReq_build_form_question_edit(question)

      this.editingQuestions.delete(studyQuestionId);
    }

    
  }
}
